import { Component, OnInit, ViewChild } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { project } from 'src/app/Models/BasicForms/project';
import { ApiService } from 'src/app/Service/api.service';
import { addDays, formatDistance } from 'date-fns';
import { DatePipe } from '@angular/common';
import { ProjectMappingComponent } from '../project-mapping/project-mapping.component';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-project-master',
  templateUrl: './project-master.component.html',
  styleUrls: ['./project-master.component.css'],
  providers: [DatePipe]
})

export class ProjectMasterComponent implements OnInit {
  constructor(public _apiService: ApiService, private notificationService: NzNotificationService, private datePipe: DatePipe, public cookie: CookieService, private router: Router) { }

  formTitle = "Projects";

  ngOnInit(): void {
    this.filterIsAppliedOrNot();
    this.getAllProjects();
    this.loadAllClients();
    this.getDefaultProject();

    this.logtext = 'OPENED - Project Master form KEYWORD[O - Project Master] ';
    this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {

    });
  }

  defaultProjectID: any;

  getDefaultProject() {
    this.defaultProjectID = sessionStorage.getItem('projectID');

  }

  projectClientID = [];
  projectClientList = [];

  loadAllClients() {
    this._apiService.getAllClients(0, 0, 'ID', 'desc', ' and IS_ACTIVE=1').subscribe(clientData => {
      this.projectClientList = clientData['data'];

    }, err => {

    });
  }

  displayFilterBox = false;

  flterBoxVisibleInvisible() {
    this.displayFilterBox = !this.displayFilterBox;
  }

  filterButtonType = "default";

  filterIsAppliedOrNot() {
    if (this.projectClientID.length > 0) {

      this.filterButtonType = "primary";

    } else {
      this.filterButtonType = "default";
    }
  }

  pageIndex = 1;
  pageSize = 9;
  totalRecords = 1;
  sortValue: string = "desc";
  logtext: string = "";
  searchText: string = "";
  columns: string[][] = [["ABBREVATION", "Abbrevation"], ["NAME", "Name"], ["DESCRIPTION", "Description"], ["PROJECT_CLIENT_NAME", "Client"], ["ESTIMATED_MANDAYS", "E Mandays"]];
  filterQuery: string = "";
  isProjectSpinning = false;
  isloadSpinning = false;
  loadingRecords = false;
  noMoreProjects = true;
  projectData = [];

  getAllProjects(reset: boolean = false) {
    this.noMoreProjects = true;

    if (reset) {
      this.pageIndex = 1;
    }

    this.loadingRecords = true;
    var sort: string;
    try {
      sort = this.sortValue.startsWith("a") ? "asc" : "desc";
      this.logtext = 'Filter Applied - Project Master form"+ sort +" "+this.sortKey +" KEYWORD [F - Project Master] ';
      this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {

      });
    } catch (error) {
      sort = "";
    }



    if (this.searchText != "") {
      if (this.cookie.get("level") == "1" || this.cookie.get("level") == "2" || this.cookie.get("level") == "3") {
        var likeQuery = " AND (";
        this.columns.forEach(column => {
          likeQuery += " " + column[0] + " like '%" + this.searchText + "%' OR";
        });

        likeQuery = likeQuery.substring(0, likeQuery.length - 2);
        likeQuery = likeQuery + ")";

      } else {
        var likeQuery = " AND (";
        this.columns.forEach(column => {
          likeQuery += " " + column[0] + " like '%" + this.searchText + "%' OR";
        });

        likeQuery = likeQuery.substring(0, likeQuery.length - 2);
        likeQuery = likeQuery + ")";
      }

    }

    this.logtext = 'Filter Applied - Project Master form "+ likeQuery +" KEYWORD [F - Project Master] ';
    this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {

    });

    this.applyFilter();

    if (this.cookie.get("level") == "1" || this.cookie.get("level") == "2" || this.cookie.get("level") == "3") {
      var filter = ""
      if (likeQuery)
        filter = this.filterQuery + likeQuery;
      else
        filter = this.filterQuery;

    } else {
      var filter = ""
      if (likeQuery)
        filter = " and USER_ID=" + this._apiService.userId + " and IS_ACTIVE=1" + this.filterQuery + likeQuery;

      else
        filter = " and USER_ID=" + this._apiService.userId + " and IS_ACTIVE=1" + this.filterQuery;
    }


    this.isloadSpinning = true;
    this.isProjectSpinning = true;

    if (this.cookie.get("level") == "1" || this.cookie.get("level") == "2" || this.cookie.get("level") == "3") {
      this._apiService.getAllProjects(this.pageIndex, this.pageSize, 'START_DATE', 'desc', filter).subscribe(data => {
        this.loadingRecords = false;
        this.isProjectSpinning = false;


        this.totalRecords = data['count'];
        this.projectData = data['data'];

        if (this.totalRecords == this.projectData.length) {
          this.noMoreProjects = false;
        }

      }, err => {

        if (err['ok'] == false)
          this.notificationService.error("Server Not Found", "");
      });

    } else {
      this._apiService.getAllMappedProjects(this.pageIndex, this.pageSize, 'START_DATE', 'desc', filter).subscribe(data => {
        this.loadingRecords = false;
        this.isProjectSpinning = false;
        this.totalRecords = data['count'];
        this.projectData = data['data'];

        if (this.totalRecords == this.projectData.length) {
          this.noMoreProjects = false;
        }

      }, err => {
        if (err['ok'] == false)
          this.notificationService.error("Server Not Found", "");
      });
    }
  }

  filterClass: string = "filter-invisible";
  isFilterApplied: string = "default";

  applyFilter() {

    if (this.projectClientID.length == 0) {
      this.filterQuery = ""
      this.isFilterApplied = "default";
    }

    else {
      this.filterQuery = " AND PROJECT_CLIENT_ID in ( " + this.projectClientID + " )"
      this.isFilterApplied = "primary";
    }

    this.filterClass = "filter-invisible";

  }

  showFilter(): void {
    if (this.filterClass === "filter-visible")
      this.filterClass = "filter-invisible";
    else
      this.filterClass = "filter-visible";
  }

  clearFilter() {
    this.filterQuery = "";
    this.projectClientID = [];

    this.getAllProjects(true);
  }

  drawerVisible = false;
  mappingDrawerVisible = false;
  drawerTitle = "";
  mappingDrawerTitle = "";
  projectDrawerData: project = new project();
  showWorkLogsLink = false;

  add() {
    this.drawerTitle = "Create Project";
    this.projectDrawerData = new project();
    this.drawerVisible = true;
    this.showWorkLogsLink = false;

    this.projectDrawerData.IS_BILLABLE = true;
    this.projectDrawerData.IS_ACTIVE = true;
    this.projectDrawerData.ESTIMATED_MANDAYS = 0;

    this.logtext = 'ADD - Project Master form KEYWORD [A - Project Master] ';
    this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {

    });

    this._apiService.getAllProjects(1, 1, 'SEQ_NO', 'desc', '').subscribe(
      (data) => {

        if (data['code'] == 200) {
          if (data['count'] == 0) {
            this.projectDrawerData.SEQ_NO = 1;
          } else {
            this.projectDrawerData.SEQ_NO = data['data'][0]['SEQ_NO'] + 1;
          }
          // this.drawerVisible = true;
        }

      },
      (err) => {

      }
    );
  }

  edit(data: project) {
    this.drawerTitle = "Update Project Details";
    this.projectDrawerData = Object.assign({}, data);
    this.drawerVisible = true;
    this.showWorkLogsLink = true;

    this.logtext = 'EDIT - Project Master form KEYWORD [E - Project Master] ';
    this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {

    });
  }

  drawerClose() {
    this.getAllProjects();
    this.drawerVisible = false;
    this.showWorkLogsLink = null;
  }

  get callBackDrawerClose() {
    return this.drawerClose.bind(this);
  }

  mappingDrawerClose() {
    this.mappingDrawerVisible = false;
  }

  get callBackMappingDrawerClose() {
    return this.mappingDrawerClose.bind(this);
  }

  mapProject(data: project) {
    this.mappingDrawerTitle = data.NAME + " Assign To : ";
    this.projectDrawerData = Object.assign({}, data);
    this.mappingDrawerVisible = true;
  }

  sortKey: string = "id";

  sort(params: NzTableQueryParams): void {
    const { pageSize, pageIndex, sort } = params;
    const currentSort = sort.find(item => item.value !== null);
    const sortField = (currentSort && currentSort.key) || 'id';
    const sortOrder = (currentSort && currentSort.value) || 'desc';
    this.pageIndex = pageIndex;
    this.pageSize = pageSize;

    if (this.pageSize != pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    }

    if (this.sortKey != sortField) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    }

    this.sortKey = sortField;
    this.sortValue = sortOrder;
    this.getAllProjects();
  }

  defaultProject(data) {
    sessionStorage.setItem("projectID", data.ID);
    this.getDefaultProject();
  }

  projectMappingDrawerData: [];
  @ViewChild(ProjectMappingComponent) ProjectMappingComponentVar: ProjectMappingComponent;

  MapForms(data: project): void {

    this.projectDrawerData = Object.assign({}, data);
    this.mappingDrawerTitle = data.NAME;
    this._apiService.getProjectDetails(data.ID, 0).subscribe(data => {
      if (data['code'] == 200) {
        this.projectMappingDrawerData = data['data'];
        this.mappingDrawerVisible = true;

      }


    }, err => {
    });



  }

  loadMoreProjects() {
    this.pageSize = this.pageSize + 3;
    this.getAllProjects();
  }

  openKanbanModal(projectInfo: project) {
    // this.isKanbanModalVisible= true;
    // this.kanbanModalName= projectInfo.NAME;

    // if(this.cookie.get("level")== "1" || this.cookie.get("level")== "2") {
    //   this.router.navigate(['/projectID', projectInfo['ID']]);

    // } else {
    //   this.router.navigate(['/projectID', projectInfo['PROJECT_ID']]);
    // }

    if (this.cookie.get("level") == "1" || this.cookie.get("level") == "2" || this.cookie.get("level") == "3") {
      sessionStorage.setItem("projectID", projectInfo.ID.toString());

    } else {
      sessionStorage.setItem("projectID", projectInfo['PROJECT_ID'].toString());
    }

    this.getDefaultProject();
  }

  getBorder(level, projectData) {
    if (level == 1 || level == 2 || level == 3) {
      if (projectData.ID == this.defaultProjectID)
        return 'solid red 1px';
      else
        return '';

    } else {
      if (projectData.PROJECT_ID == this.defaultProjectID)
        return 'solid red 1px';
      else
        return '';
    }
  }

  onEnterGetAllProjects() {
    document.getElementById("button1").focus();
    this.getDefaultProject();
  }
}
